import React, { useState, useEffect } from 'react'
import PowerBIReport from "./PowerBIReport";
import TargetReportConfig from '../../config/TargetReport';


const TargetFeedReport = (props: any) => {
   const [embedData, setEmbedData] = useState<any>(null);

    useEffect(() => {
        const fetchEmbedData = async () => {
            try {
                const response = await fetch(
                    TargetReportConfig.apiEndpoints.getTargetFeedReport,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );                              
                if (!response.ok) {
                    throw new Error('Failed to fetch Target Feed Report');
                }
                const data = await response.json();
                setEmbedData(data);
            } catch (error) {
                console.error('Error fetching Target Feed Report data:', error);
            }
        };

        fetchEmbedData();
    }, []);

    if (!embedData) {
        return <p>Loading Target Feed Report…</p>;
    }

    return <PowerBIReport {...embedData} />;
};
    
    export default TargetFeedReport;